export default __webpack_public_path__ + "static/screeny-130-gpz-mb-scheda-tecnica-de11dfefe5548dc4380b83df2e4a3d3f.pdf";